import { render, staticRenderFns } from "./SpotlightCarousel.vue?vue&type=template&id=4c70cc01&scoped=true&"
import script from "./SpotlightCarousel.vue?vue&type=script&lang=js&"
export * from "./SpotlightCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightCarousel.vue?vue&type=style&index=0&id=4c70cc01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c70cc01",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealPlanType: require('/app/appsumo/nuxt/components/DealPlanType.vue').default,TacoRating: require('/app/appsumo/nuxt/components/TacoRating.vue').default,DealPrice: require('/app/appsumo/nuxt/components/common/DealPrice.vue').default,DealImpression: require('/app/appsumo/nuxt/components/common/DealImpression.vue').default,FlickingCarousel: require('/app/appsumo/nuxt/components/FlickingCarousel.vue').default})
